import React from 'react';
import { Button } from 'react-bootstrap';
import 'components/ui/BlazeExpandButton/BlazeExpandButton.css';

interface BlazeExpandButtonProps {
  buttonText: string;
  isTextAreaExpanded: boolean;
  fnCallback?: () => void;
  buttonClass?: string; //todo className
}

const BlazeExpandButton = (props: BlazeExpandButtonProps) => {
  const { buttonText, fnCallback, isTextAreaExpanded, buttonClass } = props;
  const chevronClassName =
    'inline-span-style ' + (isTextAreaExpanded ? 'icon-bzm-chevron-up icon-xs' : 'icon-bzm-chevron-down icon-xs');

  return (
    <React.Fragment>
      <Button className={`${buttonClass}`} variant="link" onClick={fnCallback} title={buttonText}>
        <span className={`${chevronClassName} mr-1`}></span>
        {buttonText}
      </Button>
    </React.Fragment>
  );
};

export default BlazeExpandButton;
